module.exports = __webpack_public_path__ + "static/media/icon-instagram-light.8fa6d32e.svg";